import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { StorageMoveRequest } from '../../requests/pharmacy/storage-move.request';
import { StorageMoveListRequest } from '../../requests/pharmacy/storage-move-list.request';
import { ListStorageAmountLocationResponse } from '../../responses/pharmacy/list-storage-amount-location.response';
import { SectorSolicitationNonDispensationRequest } from '../../requests/pharmacy/sector-solicitation-non-dispensation.request';

@Injectable({
  providedIn: 'root'
})
export class StorageAmountLocationService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public listAllStorageAmount(body: StorageMoveListRequest): Observable<ListStorageAmountLocationResponse> {
    let uri = `StorageAmountLocation/getAll`

    return this.httpClient.post<ListStorageAmountLocationResponse>(environment.urlApiPharmacy + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      );
  }

  public returnProduct(body: StorageMoveRequest): Observable<ReturnStruct> {
    let uri = `StorageAmountLocation/moveStorage`;
    return this.httpClient.put<ReturnStruct>(environment.urlApiPharmacy + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public moveProductBySectorSolicitation(body: StorageMoveRequest): Observable<ReturnStruct> {
    let uri = `StorageAmountLocation/moveStorageBySectorSolicitation`;
    return this.httpClient.put<ReturnStruct>(environment.urlApiPharmacy + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }

  public nonDispensationBySectorSolicitation(body: SectorSolicitationNonDispensationRequest): Observable<ReturnStruct> {
    let uri = `StorageAmountLocation/nonDispensationBySectorSolicitation`;
    return this.httpClient.put<ReturnStruct>(environment.urlApiPharmacy + uri, body, this.addHeaderToken())
      .pipe(
        catchError(this.handleError)
      )
  }
}
